import { render, staticRenderFns } from "./MemberRoleChange.vue?vue&type=template&id=37591149&scoped=true"
import script from "./MemberRoleChange.vue?vue&type=script&lang=js"
export * from "./MemberRoleChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37591149",
  null
  
)

export default component.exports